import { render, staticRenderFns } from "./DrugInput.vue?vue&type=template&id=389619ae&scoped=true"
import script from "./DrugInput.vue?vue&type=script&lang=js"
export * from "./DrugInput.vue?vue&type=script&lang=js"
import style0 from "./DrugInput.vue?vue&type=style&index=0&id=389619ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389619ae",
  null
  
)

export default component.exports